<template>
  <v-card class="mt-4 mx-auto" max-width="800">
    <v-sheet
      class="v-sheet--offset mx-auto"
      color="cyan"
      elevation="12"
      max-width="calc(100% - 32px)"
    >
      <v-sparkline
        :value="value"
        color="white"
        line-width="2"
        padding="16"
      ></v-sparkline>
    </v-sheet>

    <v-card-text class="pt-0">
      <div class="title font-weight-light mb-2">
        {{ totalVisitors }} page views between {{ startDate }} - {{ endDate }}
      </div>

      <v-divider class="my-2"></v-divider>
      <v-icon class="mr-2" small>
        mdi-clock
      </v-icon>
      <span class="caption grey--text font-weight-light">duration 1 month</span>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    visitorsAndPageViews: Array
  },
  data() {
    return {}
  },
  computed: {
    labels() {
      return this.visitorsAndPageViews.map(i => i.date.substring(8, 10))
    },
    value() {
      return this.visitorsAndPageViews.map(i => i.pageViews)
    },
    totalVisitors() {
      if (this.visitorsAndPageViews.length > 0) {
        return this.visitorsAndPageViews
          .map(i => i.pageViews)
          .reduce((a, c) => a + c)
      } else {
        return 'N/A'
      }
    },
    startDate() {
      if (this.visitorsAndPageViews.length > 0) {
        return this.visitorsAndPageViews[0].date.substring(0, 10)
      } else {
        return 'N/A'
      }
    },
    endDate() {
      if (this.visitorsAndPageViews.length > 0) {
        return this.visitorsAndPageViews[
          this.visitorsAndPageViews.length - 1
        ].date.substring(0, 10)
      } else {
        return 'N/A'
      }
    }
  }
}
</script>

<style>
.v-sheet--offset {
  top: -24px;
  position: relative;
}
</style>
